export default __webpack_public_path__ + "static/media/1.4d5b67b6.png";